import { render, staticRenderFns } from "./Busstop.vue?vue&type=template&id=289a0332&"
import script from "./Busstop.vue?vue&type=script&lang=js&"
export * from "./Busstop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports